import FileSaver from 'file-saver'; 
import { document } from '~/api';

export const downloadResourceDocument = async (data = {}) => {
    if(data?.documentId == undefined || data?.documentId == '') return;
    let download_url = await getDocumentURL(data?.documentId);
    let file_extension = get_url_extension(download_url);
    fetch(download_url)
        .then(res => res.blob())
        .then((blob) => {
            FileSaver.saveAs(blob, `${data?.description}.${file_extension}`);
        });
};

function get_url_extension( url ) {
    return url.split(/[#?]/)[0].split('.').pop().trim();
}

const getDocumentURL = async(documentId) => {
    try {
        return document.getDocBase64ById(documentId)
            .then((res) => {
                //console.log('res' + JSON.stringify(res));
                return res;
            });
    } 
    catch(err) { console.error(err);
    }
};